import { createReducer } from '@reduxjs/toolkit';
import { getAddressesPage } from '../actions/addressesPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getAddressesPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
